module.exports = __webpack_public_path__ + "static/educative_jupyter-poster-16c6fe88112c4e51fb7eb0f619e4af45.jpg";